// ENGLISH dictionary, assembled by fragments, exactly like fr/.
// Each fragment carries the same keys as its counterpart in fr/; the final
// object is flat: 'space.key' -> text.
//
// NB: en/common.js also carries the packs.<id>.<field> keys, which do not
// exist on the French side (in French the product copy comes from the
// database; tp()/tpList() only read these keys for the other languages).
import common from './common';
import home from './home';
import experience from './experience';
import shop from './shop';
import fiche from './fiche';
import tunnel from './tunnel';
import regles from './regles';
import divers from './divers';

export default {
  ...common,
  ...home,
  ...experience,
  ...shop,
  ...fiche,
  ...tunnel,
  ...regles,
  ...divers,
};
